/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { StatusIconMap, useTheme } from '../utils/index.js';
import cx from 'classnames';
/**
 * Component to display icon and text below the `Combobox` component.
 * @example
 * <StatusMessage>This is the text</StatusMessage>
 * <StatusMessage startIcon={<SvgStar />}>This is the text</StatusMessage>
 */
export const StatusMessage = ({ startIcon: userStartIcon, children, status, }) => {
    useTheme();
    const StartIcon = () => {
        var _a;
        const icon = userStartIcon !== null && userStartIcon !== void 0 ? userStartIcon : (status && StatusIconMap[status]());
        if (!icon) {
            return null;
        }
        return React.cloneElement(icon, {
            className: cx('iui-input-icon', (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className),
            'aria-hidden': true,
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StartIcon, null),
        React.createElement("div", { className: 'iui-message' }, children)));
};
export default StatusMessage;
